import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-seo-services',
  templateUrl: './seo-services.component.html',
  styleUrls: ['./seo-services.component.scss']
})
export class SeoServicesComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'Search Engine Optimization - Xipe Tech';
  contentDescription = 'Boost your online visibility with XipeTech’s expert Search Engine Optimization (SEO) services. We help your business rank higher on search engines, attract more traffic, and achieve sustainable growth through proven SEO strategies.';
  contentKeywords = 'Search Engine Optimization, SEO services, SEO agency, website optimization, improve Google ranking, keyword research, on-page SEO, off-page SEO, technical SEO, link building, digital marketing, XipeTech SEO solutions';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
